import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import brandPortalOrders from "@faire/web-api--source/routes/www/brand-portal/orders";
import React, { type JSX } from "react";

import { Bold } from "../common/Bold";
import { LiItem } from "../common/LiItem";

export const RequestReviewIA = () => {
  return (
    <Column>
      <Typography>
        <StrictLocalMsg
          defaultMessage="Asking for reviews helps build relationships with current customers and trust with potential retailers. We encourage following up with customers after an order has been delivered, to request a review. You may send a message to ask directly using Faire messenger."
          description={{
            text: "Introduction to requesting reviews",
          }}
        />
      </Typography>
      <Spacer height="1x" />
      <Typography>
        <StrictLocalMsg
          defaultMessage="To message a retailer:"
          description={{
            text: "Header of the list in how to request a review",
          }}
        />
      </Typography>
      <Spacer height="1x" />
      <ol>
        <LiItem step={1}>
          <Typography>
            <StrictLocalMsg
              defaultMessage="Go to <LinkFormatting>Orders</LinkFormatting> and select the <BoldFormatting>Fulfilled</BoldFormatting> tab at the top."
              values={{
                LinkFormatting: OrdersLinkFormatting,
                BoldFormatting,
              }}
              description={{
                text: "First step to message a retailer",
              }}
            />
          </Typography>
        </LiItem>
        <Spacer height="1x" />
        <LiItem step={2}>
          <Typography>
            <StrictLocalMsg
              defaultMessage="Select an order to go to the <BoldFormatting>Order</BoldFormatting> page."
              values={{
                BoldFormatting,
              }}
              description={{
                text: "Second step to message a retailer",
              }}
            />
          </Typography>
        </LiItem>
        <Spacer height="1x" />
        <LiItem step={3}>
          <Typography>
            <StrictLocalMsg
              defaultMessage="Select the customer name to go to the <BoldFormatting>Customer</BoldFormatting> page."
              values={{
                BoldFormatting,
              }}
              description={{
                text: "Third step to message a retailer",
              }}
            />
          </Typography>
        </LiItem>
        <Spacer height="1x" />
        <LiItem step={4}>
          <Typography>
            <StrictLocalMsg
              defaultMessage="Select the <BoldFormatting>Message</BoldFormatting> button."
              values={{
                BoldFormatting,
              }}
              description={{
                text: "Fourth step to message a retailer",
              }}
            />
          </Typography>
        </LiItem>
        <Spacer height="1x" />
        <LiItem step={5}>
          <Typography>
            <StrictLocalMsg
              defaultMessage="Write and send your message to the retailer."
              description={{
                text: "Fifth step to message a retailer",
              }}
            />
          </Typography>
        </LiItem>
      </ol>
    </Column>
  );
};

const OrdersLinkFormatting = (chunks: JSX.Element) => (
  <Button variant="tertiary" linkTo={brandPortalOrders()} target="_blank">
    <Bold>{chunks}</Bold>
  </Button>
);

const BoldFormatting = (chunks: JSX.Element) => <Bold>{chunks}</Bold>;
